module.exports = {
  name: '日本語',
  key: 'ja',
  'Open in Debug Map': 'デバッグ地図で開く',
  'Open in Mapillary': 'Mapillaryで開く',
  'GPX': 'ファイルを出力する',
  'Open in editor': '編集モードで開く',
  'Open in JOSM': 'JOSMで開く',
  'Select language': '言語を選択',
  'Share Route': 'ルートを共有',
  'Link': 'リンク',
  'Shortlink': '短縮リンク',
  'Start - press enter to drop marker': '出発地 – ピンを置くにはEnterを押して下さい',
  'End - press enter to drop marker': '目的地 - ピンを置くにはEnterを押して下さい',
  'Via point - press enter to drop marker': '経由地 - ピンを置くにはEnterを押してください',
  'Build': 'ビルド: '
};
